import { AnyAction } from 'redux';

import { SET_ACTIVE_TOOLTIP } from './constants';

export interface TooltipsState {
  activeTooltip?: string;
}

const initialState: TooltipsState = {
  activeTooltip: undefined,
};

export const tooltipsReducer = (state: TooltipsState = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_ACTIVE_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.nodeId,
      };

    default:
      return state;
  }
};
